import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { axiospost } from "../../helpers/httprequest";
import is_null from "../../helpers/is_null";
import swal from "../../helpers/swal";
import useAuthStore from "../../stores/useAuthStore";

const ChangePassword = () => {
  const [loading, setloading] = useState(false);
  const [shownew, setshownew] = useState(false);
  const [showconfirm, setshowconfirm] = useState(false);
  const username = useRef();
  const password = useRef();
  const { settings } = useAuthStore();
  const navigate = useNavigate();

  const _change = async () => {
    try {
      setloading(true);
      const uname = username.current.value;
      const upass = password.current.value;
      if (is_null(uname) || is_null(upass)) {
        swal("warning", "Please fill the form properly");
        setloading(false);
        return;
      }
      if (uname !== upass) {
        swal("warning", "Please make sure the two passwords are same");
        setloading(false);
        return;
      }
      const req = await axiospost("ms_students/change", {
        password: upass,
      });
      if (req.status !== 200) {
        throw new Error("Sorry, system could not finish processing your request");
      }
      const { data } = req;
      if (data.type === "success") {
        swal("success", data.message, () => navigate("/"));
      } else {
        throw new Error(data.message);
      }
    } catch ({ message }) {
      swal("warning", message);
      setloading(false);
    }
  };

  return (
    <div className="flex min-h-screen bg-gray-50 font-sans">
      {/* Image Section */}
      <div
        className="hidden lg:flex lg:flex-[0_0_65%] flex-col justify-center items-center text-white p-10 text-center"
        style={{
          background: "linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)), url('/images/classroom.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <h1 className="text-5xl font-extrabold mb-5">{settings?.institutionName || settings?.shortName || "ATBCOE Kangere"}</h1>
        <p className="text-lg opacity-90">For security reasons, please change your password to continue.</p>
      </div>
      {/* Form Section */}
      <div className="flex flex-col justify-center items-center p-10 bg-white shadow-[-10px_0_30px_rgba(0,0,0,0.05)] flex-[0_0_35%] max-lg:flex-[0_0_100%]">
        <div className="flex justify-center mb-8 mt-16">
          <img src={settings?.logo || "/images/college-logo.png"} alt="Institution Logo" className="h-20" onError={(e) => { e.target.onerror = null; e.target.src = "/images/college-logo.png"; }} />
        </div>
        <div className="text-center mb-4">
          <h4 style={{ fontWeight: 700 }}>CHANGE PASSWORD</h4>
          <p className="text-muted">Set a new secure password for your account</p>
        </div>
        <div className="w-full max-w-[400px]">
          <div className="form-group mb-3">
            <label className="mb-2 font-weight-bold">New Password</label>
            <div className="input-group">
              <input
                type={shownew ? "text" : "password"}
                className="form-control py-2"
                placeholder="New Password"
                ref={username}
              />
              <button className="btn btn-outline-secondary" type="button" onClick={() => setshownew(!shownew)}>
                <i className={shownew ? "fa fa-eye-slash" : "fa fa-eye"}></i>
              </button>
            </div>
          </div>
          <div className="form-group mb-4">
            <label className="mb-2 font-weight-bold">Confirm Password</label>
            <div className="input-group">
              <input
                type={showconfirm ? "text" : "password"}
                className="form-control py-2"
                placeholder="Confirm Password"
                ref={password}
              />
              <button className="btn btn-outline-secondary" type="button" onClick={() => setshowconfirm(!showconfirm)}>
                <i className={showconfirm ? "fa fa-eye-slash" : "fa fa-eye"}></i>
              </button>
            </div>
          </div>
          <button
            className="btn btn-primary w-100 py-3 font-weight-bold"
            disabled={loading}
            onClick={_change}
          >
            {loading ? "Updating..." : "Update Password"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
